/*
 * ******************************************************************************
 * Copyright Innov'ATM all rights reserved. This software is the property of
 * Innov'ATM and may not be used in any manner except under a license agreement
 * signed with Innov'ATM.
 * *******************************************************************************
 */

import { ReactNode } from 'react';

/**
 * Displays the IATA code. When the IATA code is missing, the ICAO code is displayed instead, in
 * italic, to signal that it is a fallback. When both are missing, the provided fallback is rendered.
 */
export function IataIcao({ iata, icao, fallback = null }: { iata?: string; icao?: string; fallback?: ReactNode }) {
    if (iata) {
        return <>{iata}</>;
    }
    if (icao) {
        return <span style={{ fontStyle: 'italic' }}>{icao}</span>;
    }
    return <>{fallback}</>;
}
